export function formatAccountNumber(acc) {
    if (!acc) return "-";
    const cleaned = acc.replace(/\s+/g, '');
    return cleaned.replace(/(.{4})/g, '$1 ').trim();
}
export const maskedAccNumber = (acc)=>{
    if (!acc) return "-";
    const cleaned = acc.replace(/\s+/g, '');
    const len = cleaned.length;
    if(len <= 4) {
      return cleaned;
    }
    const maskedLength = len - 4;
    let masked = '';
    for(let i=0; i < maskedLength; i++) {
      masked += '*';
    }
    masked += cleaned.slice(-4);
    return masked.match(/.{1,4}/g).join(' ');
}
export const generateRandomChars = () => {
    return Array(4).fill(0).map(() => String.fromCharCode(65 + Math.floor(Math.random() * 26))).join('');
}
export const generateTimestamp = () => {
    return Math.floor(Date.now()).toString().toUpperCase();
}

export const combineAndTruncate = (str1, str2, maxLength) => {
    return (str1 + str2).substr(0, maxLength);
}
  export const generateUniqueId = () => {
    const randomChars = generateRandomChars();
    const timestamp = generateTimestamp();
    return combineAndTruncate(randomChars, timestamp, 15);
  }
  
export const txnTypeMethod = [
    {label:'Select Method',value:''},
    {label:'To ICICI',value:'ICICI'},
    {label:'RTGS',value:'RTGS'},
    {label:'NEFT',value:'NEFT'},
    {label:'IMPS',value:'IMPS'},

]

